export default __webpack_public_path__ + "static/media/algorithms.71b47bf0.png";